import React from "react";

const WorkoutPlan = () => {
  return (
    <div className="section" id="workouts">
      <h2>Workouts</h2>
      <p>
        I used AI to help me focus on a couple of key routines that I try and run almost weekly. There is also an AI Prompt that can help you create a similar workout routine. You can also add your equipment list to the prompt which will help keep within your constraints. These are 30 to 45-minute workouts that I rotate into and try to get in 5 times total a week.
      </p>
      <p>
        <strong>Note:</strong> In addition, I do several walks, ruck-walks (25lb weight vest), and usually two days of each (jogging, rowing, and elliptical) into this routine.
      </p>

      <h3>Intense Core (3 sets each 2X a week)</h3>
      <ul>
        <li>Planks: 90 seconds</li>
        <li>Bicycle Crunches: 15 reps per side with leg weights</li>
        <li>Russian Twists: 15 reps per side (I do this with a Kettlebell)</li>
        <li>Leg Raises: 12 - 15 reps with leg weights</li>
        <li>Side Plank: 30 seconds each side</li>
        <li>Flutter Kicks: 15 reps per side with leg weights</li>
      </ul>

      <h3>Intense Upper Body-1 (3 sets each)</h3>
      <ul>
        <li>Push Ups: 20 - 25 reps</li>
        <li>Standing Shoulder Press: 12 reps (I do this with dumbbells)</li>
        <li>Bent Over Rows: 10 - 12 reps (I do this with the resistance band)</li>
        <li>Overhead Triceps: 10 - 12 reps each arm (I do this with the resistance band)</li>
        <li>Lateral Raises: 10 - 12 reps each arm (I do this with dumbbells)</li>
        <li>Front Raises: 10 reps (I added this item recently using dumbbells)</li>
      </ul>

      <h3>Intense Leg (3 sets each)</h3>
      <ul>
        <li>Squats: 10 - 15 reps with the Kettlebell</li>
        <li>Lunges: 10 - 12 reps with Dumbbells</li>
        <li>Dead lifts: 10 - 12 reps with the Kettlebell</li>
        <li>Calf Raises: 15 - 20 reps with the Kettlebell</li>
        <li>Glute Bridges: 12 - 15 reps</li>
      </ul>

      <h3>Intense Upper Body-2 (3 sets each)</h3>
      <ul>
        <li>Push Ups: 20 - 25 reps (I want to swap this with pull-ups but don't have a bar)</li>
        <li>Bench Press: 12 - 15 reps (I do this with the resistance band since I don't have a bench)</li>
        <li>Bicep or Hammer Curls: 12 - 15 reps with Dumbbells</li>
        <li>Front Raises: 10 - 12 reps</li>
        <li>Push-up Planks: 10 - 12 reps</li>
      </ul>

      <h3>Intense HIIT (3 sets each/30 sec break between each exercise)</h3>
      <ul>
        <li>Thruster Dumbbells: 10 reps</li>
        <li>Kettlebell Swing: 10 reps</li>
        <li>Push-ups: 15-20 reps</li>
        <li>Hammer Curls Dumbbells: 8 reps</li>
        <li>Forward Lunges: 8 reps</li>
        <li>Kettlebell Goblet Squats: 10 reps</li>
        <li>Lateral Raises: 10 reps</li>
        <li>Leg Raises with weights: 10 reps</li>
      </ul>

      <h3>Rest Guidelines</h3>
      <ul>
        <li>Allow 48 hours between stomach workouts</li>
        <li>Allow 72 hours between upper body workouts</li>
        <li>Allow 72 hours between leg workouts</li>
        <li>Take 1 - 2 full rest days per week</li>
      </ul>

      <h3>Additional Notes (Sometimes I may do the following)</h3>
      <ul>
        <li>Try and perform 2-3 warm-up sets before main exercises</li>
        <li>Rest 60 - 90 seconds between sets</li>
        <li>Progressive overload: Increase weight by 2.5-5% when you can complete all reps with proper form</li>
        <li>Include 5-10 minutes of moderate-intensity cardio after strength training</li>
      </ul>
    </div>
  );
};

export default WorkoutPlan;

